import { Component, OnInit, Input, OnChanges, ViewEncapsulation } from '@angular/core';
import { QueryEditorComponent } from '../query-editor.component';
import { UntypedFormControl, UntypedFormArray } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { debounceTime, map, mergeMap } from 'rxjs/operators';
import { YukkApi } from 'src/app/service/yukkapi.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-query-editor-search',
  templateUrl: './query-editor-search.component.html',
  styleUrls: ['./query-editor-search.component.scss']
})
export class QueryEditorSearchComponent implements OnInit, OnChanges {

  mySearch: UntypedFormControl;
  @Input('data') data: any;
  items$: Observable<YukkApi>;
  params: any;
  name: string;
  value: string;
  input: string;
  error: boolean;
  label = 'Search';
  entity: boolean;
  oldOperator: string;

  constructor(
    public query: QueryEditorComponent,
    private yukkApi: YukkApi,
    private route: ActivatedRoute,
  ) {
    this.route.queryParams.subscribe(params => {
      this.params = params;
    });
  }

  ngOnInit() {
    this.oldOperator = this.data.operator;
    if (this.data.name) {
      this.mySearch = new UntypedFormControl(this.data.name);
    } else {
      this.mySearch = new UntypedFormControl(this.data.value);
    }
    if (this.data.value === '') {
      this.label = '';
    } else {
      if (this.data.hasOwnProperty('field') && (this.data.field !== '')) {
        if (this.data.field === 'entity') {
          if (this.data.value.split(':')[1]) {
            this.label = this.data.value.split(':')[0];
          }
        } else if ((this.data.field === 'super_event') || (this.data.field === 'event') || (this.data.field === 'sub_event')) {
          this.label = 'Event';
        } else if (this.data.field === 'word') {
          this.label = 'Text';
        }  else {
          this.label = this.data.field;
        }
      } else {
        this.label = '';
      }
    }
    // if (this.data.value.split(':')[1]) {
    //   this.label = this.data.value.split(':')[0];
    // } else {
    //   if (this.data.value.split('_')[1]) {
    //     this.label = 'Event';
    //   } else {
    //     this.label = 'Source';
    //   }
    // }
    this.mySearch.valueChanges.pipe(debounceTime(1000)).subscribe(value => {
      this.initSearch(value);
    });
  }

  ngOnChanges() {
    if ( (this.oldOperator !== this.data.operator) && ( (this.oldOperator === 'near') || (this.data.operator === 'near') ) ) {
      this.label = 'Text';
      if (this.data && this.data.input !== null) {
        this.mySearch = new UntypedFormControl(this.data.input.trim());
      } else {
        this.mySearch = new UntypedFormControl('');
      }
      this.mySearch.valueChanges.pipe(debounceTime(1000)).subscribe(value => {
        this.initSearch(value);
      });
    }
    this.oldOperator = this.data.operator;
  }

  initSearch(value) {
    if (!this.entity) {
      // this.label = 'Text';
      if (this.data.level === 0) {
        const rule = this.query.queryForm.get('filters') as UntypedFormArray;
        rule.controls[this.data.index].get('name').setValue('');
        rule.controls[this.data.index].get('value').setValue(value);
        if (typeof value !== 'object') {
          rule.controls[this.data.index].get('input').setValue(value);
        }
        rule.controls[this.data.index].get('field').setValue('text');
      } else {
        const groups = this.query.queryForm.get('groups') as UntypedFormArray;
        const filters = groups.at(this.data.groups).get('filters') as UntypedFormArray;
        filters.controls[this.data.index].get('name').setValue('');
        filters.controls[this.data.index].get('value').setValue(value);
        if (typeof value !== 'object') {
          filters.controls[this.data.index].get('input').setValue(value);
        }
        if (this.data.operator === 'near') {
          filters.controls[this.data.index].get('field').setValue('word');
        } else {
          filters.controls[this.data.index].get('field').setValue('text');
        }
      }
    }
    this.entity = false;
    if ( value && ( value.length > 1 ) ) {
      // version with search results and counts loaded at the same time
      // this.items$ = this.yukkApi.search_meta(value, this.params).pipe(map(result => {
      //   return result;
      // }));
      // version with counts loaded after search results
      this.items$ = this.yukkApi.search_meta_fast(value, this.params).pipe(mergeMap(result => {
        const portfolio = [];
        if (result && (result.entity_prefix_search.hits.length === 0) && (result.event_search.hits.length === 0) && (result.source_prefix_search.hits.length === 0)) {
          const words = value.split(' ').filter(item => (item !== ''));
          return this.yukkApi.search_meta_fast(words[0] ? words[0] : ' ', this.params).pipe(map(result2 => {
            // @ts-ignore
            result2['entity_prefix_search']['hits'].forEach(item => {
              const compound_key = item.entity.type + ':' + item.entity.alpha_id;
              portfolio.push(compound_key);
            });
            this.yukkApi.newsCountItemized(this.params, portfolio).subscribe(resArg2 => {
              const res2 = JSON.parse(JSON.stringify(resArg2));
              const countsObject = {};
              res2.result.forEach(item => {
                countsObject[item.entity_info.alpha_id] = item.count;
              });
              const entitiesWithCounts = [];
              // @ts-ignore
              result2['entity_prefix_search']['hits'].forEach((item, index) => {
                result2['entity_prefix_search']['hits'][index].count = countsObject[item.entity.alpha_id];
              });
            });
            return result2;
          }));
        } else {
          // @ts-ignore
          result['entity_prefix_search']['hits'].forEach(item => {
            const compound_key = item.entity.type + ':' + item.entity.alpha_id;
            portfolio.push(compound_key);
          });
          this.yukkApi.newsCountItemized(this.params, portfolio).subscribe(resArg2 => {
            const res2 = JSON.parse(JSON.stringify(resArg2));
            const countsObject = {};
            res2.result.forEach(item => {
              countsObject[item.entity_info.alpha_id] = item.count;
            });
            const entitiesWithCounts = [];
            // @ts-ignore
            result['entity_prefix_search']['hits'].forEach((item, index) => {
              result['entity_prefix_search']['hits'][index].count = countsObject[item.entity.alpha_id];
            });
          });
          return of(result);
        }
      }));
    }
  }

  goSelect(option) {
    if (option.type === 'freetext') {
      this.label = 'Text';
      this.mySearch.setValue(option.name);
      const groups = this.query.queryForm.get('groups') as UntypedFormArray;
      const filters = groups.at(this.data.groups).get('filters') as UntypedFormArray;
      filters.controls[this.data.index].get('field').setValue('text');
    } else if (option.type === 'word') {
      this.label = 'Text';
      this.mySearch.setValue(option.name);
      const groups = this.query.queryForm.get('groups') as UntypedFormArray;
      const filters = groups.at(this.data.groups).get('filters') as UntypedFormArray;
      filters.controls[this.data.index].get('field').setValue('word');
    } else if (option.type === 'source') {
      this.label = 'Source';
      this.entity = true;
      const groups = this.query.queryForm.get('groups') as UntypedFormArray;
      const filters = groups.at(this.data.groups).get('filters') as UntypedFormArray;
      filters.controls[this.data.index].get('name').setValue(option.option.url);
      filters.controls[this.data.index].get('value').setValue(option.option.url);
      filters.controls[this.data.index].get('field').setValue('source');
      this.mySearch.setValue(option.option.url);
    } else if (option.type === 'event') {
      this.label = 'Event';
      this.entity = true;
      const groups = this.query.queryForm.get('groups') as UntypedFormArray;
      const filters = groups.at(this.data.groups).get('filters') as UntypedFormArray;
      filters.controls[this.data.index].get('name').setValue(option.option.name);
      filters.controls[this.data.index].get('value').setValue(option.option.id);
      filters.controls[this.data.index].get('field').setValue(option.option.type);
      this.mySearch.setValue(option.option.name);
    } else {
      const name = option.entity.name;
      const keyd = option.entity.type + ':' + option.entity.alpha_id;
      this.label = option.entity.type;
      this.entity = true;
      if (this.data.level === 0) {
        const rule = this.query.queryForm.get('filters') as UntypedFormArray;
        rule.controls[this.data.index].get('name').setValue(name);
        rule.controls[this.data.index].get('value').setValue(keyd);
        rule.controls[this.data.index].get('field').setValue('entity');
      } else {
        const groups = this.query.queryForm.get('groups') as UntypedFormArray;
        const filters = groups.at(this.data.groups).get('filters') as UntypedFormArray;
        filters.controls[this.data.index].get('name').setValue(name);
        filters.controls[this.data.index].get('value').setValue(keyd);
        filters.controls[this.data.index].get('field').setValue('entity');
      }
      this.mySearch.setValue(name);
    }
  }

  inBlur(value) {
    this.initSearch(value);
  }

  onSearchChange(value) {
    if (value === '') {
      this.label = '';
    } else {
      this.label = 'Text';
    }
  }

  /**
   *
   */
  iMatch(entity) {
    if (entity.matched_form) {
      return entity.name.charAt(0).toLowerCase() !== entity.matched_form.charAt(0);
    }
  }

  /**
   * format big numbers >999 into K, M, ...
   */
  numberFormat(num) {
    if (num || (num === 0) || (num === '0')) {
      // @ts-ignore
      return Intl.NumberFormat('en', { notation: 'compact' }).format(num);
    } else {
      return '';
    }
  }

}
